// extracted by mini-css-extract-plugin
export default {"video":"ghg_NtfGSn"};